"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtCopy = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtCopy = function SvgBtCopy(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.8229 22.0001H8.48962C7.47827 22.0001 6.65625 21.1781 6.65625 20.1667V11.1667C6.65625 10.1554 7.47827 9.3335 8.48962 9.3335H8.82288C9.09888 9.3335 9.32288 9.5575 9.32288 9.8335C9.32288 10.1095 9.09888 10.3335 8.82288 10.3335H8.48962C8.03027 10.3335 7.65625 10.7074 7.65625 11.1667V20.1667C7.65625 20.6261 8.03027 21.0001 8.48962 21.0001H16.8229C17.2822 21.0001 17.6562 20.6261 17.6562 20.1667V19.8335C17.6562 19.5575 17.8802 19.3335 18.1562 19.3335C18.4323 19.3335 18.6562 19.5575 18.6562 19.8335V20.1667C18.6562 21.1781 17.8342 22.0001 16.8229 22.0001V22.0001Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.4896 18H12.4896C11.4783 18 10.6562 17.178 10.6562 16.1666V7.83337C10.6562 6.82202 11.4783 6 12.4896 6H19.4896C20.501 6 21.3229 6.82202 21.3229 7.83337V16.1666C21.3229 17.178 20.501 18 19.4896 18ZM12.4896 7C12.0303 7 11.6562 7.37402 11.6562 7.83337V16.1666C11.6562 16.626 12.0303 17 12.4896 17H19.4896C19.949 17 20.3229 16.626 20.3229 16.1666V7.83337C20.3229 7.37402 19.949 7 19.4896 7H12.4896Z",
    fill: "currentColor"
  }));
};

exports.SvgBtCopy = SvgBtCopy;